module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/sysman/src/app/app.component.html
// module id = 1619
// module chunks = 2